/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, localDateString } from '../runtime';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';
import type { UpdatedAt } from './UpdatedAt';
import { UpdatedAtFromJSON, UpdatedAtFromJSONTyped, UpdatedAtToJSON } from './UpdatedAt';
import type { UpdatedBy } from './UpdatedBy';
import { UpdatedByFromJSON, UpdatedByFromJSONTyped, UpdatedByToJSON } from './UpdatedBy';

/**
 *
 * @export
 * @interface EventAdminModel
 */
export interface EventAdminModel {
    /**
     *
     * @type {string}
     * @memberof EventAdminModel
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof EventAdminModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof EventAdminModel
     */
    link: string;
    /**
     *
     * @type {Date}
     * @memberof EventAdminModel
     */
    date: Date;
    /**
     *
     * @type {Date}
     * @memberof EventAdminModel
     */
    createdAt: Date;
    /**
     *
     * @type {UpdatedAt}
     * @memberof EventAdminModel
     */
    updatedAt?: UpdatedAt;
    /**
     *
     * @type {string}
     * @memberof EventAdminModel
     */
    createdBy: string;
    /**
     *
     * @type {UpdatedBy}
     * @memberof EventAdminModel
     */
    updatedBy?: UpdatedBy;
    /**
     *
     * @type {string}
     * @memberof EventAdminModel
     */
    description: string;
    /**
     *
     * @type {FileUrl}
     * @memberof EventAdminModel
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the EventAdminModel interface.
 */
export function instanceOfEventAdminModel(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('link' in value)) return false;
    if (!('date' in value)) return false;
    if (!('createdAt' in value)) return false;
    if (!('createdBy' in value)) return false;
    if (!('description' in value)) return false;
    return true;
}

export function EventAdminModelFromJSON(json: any): EventAdminModel {
    return EventAdminModelFromJSONTyped(json, false);
}

export function EventAdminModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): EventAdminModel {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        link: json['link'],
        date: new Date(json['date']),
        createdAt: new Date(json['created_at']),
        updatedAt: json['updated_at'] == null ? undefined : UpdatedAtFromJSON(json['updated_at']),
        createdBy: json['created_by'],
        updatedBy: json['updated_by'] == null ? undefined : UpdatedByFromJSON(json['updated_by']),
        description: json['description'],
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function EventAdminModelToJSON(value?: EventAdminModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        link: value['link'],
        date: localDateString(value['date']),
        created_at: value['createdAt'].toISOString(),
        updated_at: UpdatedAtToJSON(value['updatedAt']),
        created_by: value['createdBy'],
        updated_by: UpdatedByToJSON(value['updatedBy']),
        description: value['description'],
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
